import { render, staticRenderFns } from "./ModalDuelsGame.vue?vue&type=template&id=f9785ea4&scoped=true"
import script from "./ModalDuelsGame.vue?vue&type=script&lang=js"
export * from "./ModalDuelsGame.vue?vue&type=script&lang=js"
import style0 from "./ModalDuelsGame.vue?vue&type=style&index=0&id=f9785ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9785ea4",
  null
  
)

export default component.exports